import React, { Component, Fragment } from "react";
import { Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import docsService from "../../Services/docsService";
import { toast } from "react-toastify";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import "../../assets/css/questions.css";
import Swal from "sweetalert2";
import { generalErrMsg } from "../../global/popupMessages";
import SectionPanel from "./sectionPanel";

// Multipliers
var SELLER_SECTION = "פרטי המוכרים";
var BUYER_SECTION = "פרטי הקונים";
var THIRD_SECTION = "צד שלישי";

class QuestionsPage extends Component {
  state = {
    sellersPanel: {},
    buyersPanel: {},
    thidPanel: {},
    propertyPanel: {},
    lawyersPanel: {},
    generalPanel: {},

    isSectionExpended: [true, true, true, true, true, true],
    questionsSteps: null,
    listOfShownToolTips: [],
    isLawyerView: true,
    docsList: null,
    sellersData: [], // i think it refers for the extra ones.. not sure..
    buyersData: [],
    thirdData: []
  };

  componentDidMount() {
    var docsList = this.props.newDocsSelected;
    // props comes from a user which is a lawyer and params is filling by email
    var dealId = this.props.dealId || this.props.match.params.dealId;
    var clientEmail = this.props.match.params.clientEmail;

    var jsonState = {};
    var isLawyerView = true;
    if (clientEmail) {
      isLawyerView = false;
      jsonState["clientEmail"] = clientEmail;
    }
    jsonState["isLawyerView"] = isLawyerView;
    jsonState["dealId"] = dealId;

    this.setState(jsonState);

    docsService.getFields(docsList, dealId, isLawyerView, clientEmail).then((res) => {
      if (res["success"]) {
        var dealDataQuestions = res["fieldsFromDB"];
        var savedFields = res["fields"];
        var getSellerAmount = res["sellersAmount"];
        var getBuyerAmount = res["buyersAmount"];
        var getThirdAmount = res["thirdAmount"];

        this.setState({
          questionsSteps: dealDataQuestions,
          docsList
        });

        for (let i = 0; i < getSellerAmount; i++) this.addAnotherClientToDeal(SELLER_SECTION);

        for (let i = 0; i < getBuyerAmount; i++) this.addAnotherClientToDeal(BUYER_SECTION);

        for (let i = 0; i < getThirdAmount; i++) this.addAnotherClientToDeal(THIRD_SECTION);

        var fields = { sellersPanel: {}, buyersPanel: {}, thidPanel: {}, propertyPanel: {}, lawyersPanel: {}, generalPanel: {} };

        for (const key in savedFields) {
          var isKeyFound = false;
          for (let index = 0; index < dealDataQuestions.length; index++) {
            var panel = dealDataQuestions[index];
            const currentPanelFields = fields[this.getCorrectJsonFields(index)];

            for (const question of panel.questions) {
              // isMatch, isSimilar, keyToUse, suffix
              var keysData = this.getKeyOrSimilar(question.key, key);
              if (keysData.isMatch) {
                if (question.optionsKey) {
                  for (const option of question.options) {
                    if (savedFields[option.key + keysData.suffix]) {
                      if (!currentPanelFields[question.optionsKey + keysData.suffix]) {
                        currentPanelFields[question.optionsKey + keysData.suffix] = option.key + keysData.suffix;
                      } else {
                        currentPanelFields[question.optionsKey + keysData.suffix] += ";:;" + option.key + keysData.suffix;
                      }
                    }
                  }
                } else {
                  currentPanelFields[key] = savedFields[key];
                }
                isKeyFound = true;
                break;
              }
            }
            if (isKeyFound) break;
          }
        }
        this.setState({
          sellersPanel: fields.sellersPanel,
          buyersPanel: fields.buyersPanel,
          thidPanel: fields.thidPanel,
          propertyPanel: fields.propertyPanel,
          lawyersPanel: fields.lawyersPanel,
          generalPanel: fields.generalPanel
        });
      }
    });
  }

  render() {
    return (
      <div className="mt-50">
        <h3 className="yellow-color">שאלות למילוי המסמכים</h3>
        <div className="mt-20">
          <Card>
            <CardContent className="questions-card">
              <div className="mb-20">
                {this.state.isLawyerView ? (
                  <div className="inline-block">
                    <Button onClick={this.saveFields} color="primary" variant="contained" size="small">
                      שמור
                      <i className="material-icons width40">save</i>
                    </Button>

                    <Button className="mr-20" onClick={this.createDocs} color="primary" variant="contained" size="small">
                      הפק טפסים
                      <i className="material-icons width40">create_new_folder</i>
                    </Button>

                    <Button
                      size="small"
                      className="mr-20 send-client-email-btn"
                      onClick={(e) => {
                        this.createDocs(e, true);
                      }}
                      variant="contained"
                    >
                      שלח את הטפסים באימייל
                      <i className="material-icons width40">mail_outline</i>
                    </Button>
                  </div>
                ) : (
                  <Button onClick={this.saveFields} color="primary" variant="contained" size="small">
                    שלח לעורך הדין
                    <i className="material-icons width40">save</i>
                  </Button>
                )}
              </div>

              {this.state.questionsSteps != null
                ? this.state.questionsSteps.map((item, panelIndex) => {
                    return (
                      <Fragment key={panelIndex}>
                        {item.questions && item.questions[0] ? (
                          <SectionPanel
                            isSectionExpended={this.state.isSectionExpended[panelIndex]}
                            sectionName={item.sectionName}
                            questions={item.questions}
                            curJsonData={this.state[this.getCorrectJsonFields(panelIndex)]}
                            handlePanelChange={this.handlePanelChange}
                            panelIndex={panelIndex}
                            isQuestionShown={this.isQuestionShown}
                            handleFieldChange={this.handleFieldChange}
                            handleCheckboxChange={this.handleCheckboxChange}
                            addAnotherClientToDeal={this.addAnotherClientToDeal}
                            removeExtraClientsFromDeal={this.removeExtraClientsFromDeal}
                            handleFirstInteractionWithEle={this.handleFirstInteractionWithEle}
                            sellersData={this.state.sellersData}
                            buyersData={this.state.buyersData}
                            thirdData={this.state.thirdData}
                          />
                        ) : null}
                      </Fragment>
                    );
                  })
                : null}
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  getCorrectJsonFields = (index) => {
    if (index === 1) return "sellersPanel";
    if (index === 2) return "buyersPanel";
    if (index === 3) return "thidPanel";
    if (index === 4) return "propertyPanel";
    if (index === 5) return "lawyersPanel";
    return "generalPanel";
  };

  getKeyOrSimilar = (key, keyToCompare) => {
    if (key === keyToCompare) return { isMatch: true, isSimilar: false, keyToUse: key, suffix: "" };
    if (!isNaN(keyToCompare[keyToCompare.length - 1]) && key === keyToCompare.substring(0, keyToCompare.length - 1)) {
      return { isMatch: true, isSimilar: true, keyToUse: keyToCompare, suffix: keyToCompare[keyToCompare.length - 1] };
    } else {
      return { isMatch: false };
    }
  };

  addAnotherClientToDeal = (sectionName) => {
    var questionsList = [];
    var clientDataToCopy, focusPanel;
    if (sectionName === SELLER_SECTION) {
      clientDataToCopy = [...this.state.sellersData];
      focusPanel = this.state.questionsSteps[0].questions;
    } else if (sectionName === BUYER_SECTION) {
      clientDataToCopy = [...this.state.buyersData];
      focusPanel = this.state.questionsSteps[1].questions;
    } else if (sectionName === THIRD_SECTION) {
      clientDataToCopy = [...this.state.thirdData];
      focusPanel = this.state.questionsSteps[2].questions;
    }

    if (clientDataToCopy.length >= 2) {
      return;
    }

    var currentClientNumber = clientDataToCopy.length + 2;
    for (const panelQuestion of focusPanel) {
      var tmpNewQuestion = { ...panelQuestion };
      if (tmpNewQuestion.optionsKey) {
        tmpNewQuestion.optionsKey = tmpNewQuestion.optionsKey + currentClientNumber;
        var options = [];
        for (let i = 0; i < tmpNewQuestion.options.length; i++) {
          options.push({
            key: tmpNewQuestion.options[i].key + currentClientNumber,
            label: tmpNewQuestion.options[i].label
          });
        }
        tmpNewQuestion.options = options;
      } else {
        tmpNewQuestion.key = tmpNewQuestion.key + currentClientNumber;
      }
      questionsList.push(tmpNewQuestion);
    }
    clientDataToCopy.push(questionsList);

    if (sectionName === SELLER_SECTION) this.setState({ sellersData: clientDataToCopy });
    else if (sectionName === BUYER_SECTION) this.setState({ buyersData: clientDataToCopy });
    else if (sectionName === THIRD_SECTION) this.setState({ thirdData: clientDataToCopy });
  };

  removeExtraClientsFromDeal = (sectionName, indexOfClient) => {
    var clientDataList, fieldSectionCopy;
    if (sectionName === SELLER_SECTION) {
      clientDataList = [...this.state.sellersData];
      fieldSectionCopy = { ...this.state.sellersPanel };
    } else if (sectionName === BUYER_SECTION) {
      clientDataList = [...this.state.buyersData];
      fieldSectionCopy = { ...this.state.buyersPanel };
    } else {
      clientDataList = [...this.state.thirdData];
      fieldSectionCopy = { ...this.state.thidPanel };
    }

    // delete data related to the deleted client
    for (const item of clientDataList[indexOfClient]) {
      if (item.type === "checkbox" || item.type === "radio") {
        delete fieldSectionCopy[item.optionsKey];
      } else {
        delete fieldSectionCopy[item.key];
      }
    }

    // 1 is actually like 3... because its the second in the list which is third seller.
    if (indexOfClient == 1 || clientDataList.length === 1) clientDataList.pop();
    else {
      for (const item of clientDataList[indexOfClient + 1]) {
        if (item.type === "checkbox" || item.type === "radio") {
          var newVal = fieldSectionCopy[item.optionsKey];
          if (newVal) {
            newVal = newVal
              .split(";:;")
              .map((item) => this.constructNewIndexKey(item, 2, 3))
              .join(";:;");
            if (newVal) fieldSectionCopy[this.constructNewIndexKey(item.optionsKey, 2, 3)] = newVal;
          }
        } else {
          var newVal = fieldSectionCopy[item.key];
          if (newVal) fieldSectionCopy[this.constructNewIndexKey(item.key, 2, 3)] = newVal;
        }
      }

      for (const item of clientDataList[indexOfClient + 1]) {
        if (item.type === "checkbox" || item.type === "radio") {
          delete fieldSectionCopy[item.optionsKey];
        } else {
          delete fieldSectionCopy[item.key];
        }
      }

      clientDataList[1] = this.alterKeysWithMultiIndex(clientDataList[1], indexOfClient, indexOfClient + 1);
      clientDataList = clientDataList.splice(1, 2);
    }

    if (sectionName === SELLER_SECTION) {
      this.setState({ sellersPanel: fieldSectionCopy, sellersData: clientDataList });
    } else if (sectionName === BUYER_SECTION) {
      this.setState({ buyersPanel: fieldSectionCopy, buyersData: clientDataList });
    } else {
      clientDataList = this.setState({ thidPanel: fieldSectionCopy, thirdData: clientDataList });
    }
  };

  saveFields = () => {
    var fieldsToSave = this.getFields();
    var sellersAmount = this.state.sellersData.length;
    var buyersAmount = this.state.buyersData.length;
    var thirdAmount = this.state.thirdData.length;

    docsService
      .saveFields(
        this.state.dealId,
        fieldsToSave,
        sellersAmount,
        buyersAmount,
        thirdAmount,
        this.state.clientEmail,
        this.state.isLawyerView
      )
      .then((res) => {
        if (res["success"]) {
          if (this.state.isLawyerView) {
            Swal.fire("שינויים נשמרו בהצלחה", "", "success");
          } else {
            this.props.history.push("/message/sent-lawyer");
          }
        } else {
          Swal.fire("", generalErrMsg, "warning");
        }
      });
  };

  createDocs = (e, isSendByEmail) => {
    if (!this.state.docsList || !this.state.docsList[0]) {
      // redirect user to choose docs
      return;
    }

    var fieldsToSave = this.getFields();
    var sellersAmount = this.state.sellersData.length;
    var buyersAmount = this.state.buyersData.length;
    var thirdAmount = this.state.thirdData.length;

    if (isSendByEmail) {
      Swal.fire({
        title: "שליחת מסמכים לאימייל",
        text: "",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "שלח",
        cancelButtonText: "בטל",
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          if (!email) return false;
          docsService
            .generateDocs(
              this.state.dealId,
              this.state.docsList,
              fieldsToSave,
              isSendByEmail,
              email,
              sellersAmount,
              buyersAmount,
              thirdAmount
            )
            .then((res) => {
              if (res["success"]) {
                Swal.fire("מסמכים נשלחו למייל", email, "success");
              } else if (res["badEmailFormat"]) {
                Swal.fire("", res["badEmailFormat"], "warning");
              } else {
                Swal.fire("", generalErrMsg, "warning");
              }
            });
        }
      });
    } else {
      docsService
        .generateDocs(this.state.dealId, this.state.docsList, fieldsToSave, isSendByEmail, null, sellersAmount, buyersAmount, thirdAmount)
        .then((res) => {
          if (!res["success"]) Swal.fire("", generalErrMsg, "warning");
        });
    }
  };

  // sellerFirstName2, sellerFirstName3.. etc.
  // indexToRemove is to modify client with suffix 3 to 2 for example - in case of deleting client 2 and there is client 3
  alterKeysWithMultiIndex = (listToAlter, newIndex, prevIndex) => {
    var newPanelQuestions = [];
    newIndex = newIndex + 2;
    prevIndex = prevIndex + 2;
    for (const panelQuestion of listToAlter) {
      var tmpNewQuestion = { ...panelQuestion };
      if (tmpNewQuestion.optionsKey) {
        tmpNewQuestion.optionsKey = this.constructNewIndexKey(tmpNewQuestion.optionsKey, newIndex, prevIndex);
        // tmpNewQuestion.optionsKey = tmpNewQuestion.optionsKey + currentClientNumber;
        var options = [];
        for (let i = 0; i < tmpNewQuestion.options.length; i++) {
          options.push({
            key: this.constructNewIndexKey(tmpNewQuestion.options[i].key, newIndex, prevIndex),
            label: tmpNewQuestion.options[i].label
          });
        }
        tmpNewQuestion.options = options;
      } else {
        tmpNewQuestion.key = this.constructNewIndexKey(tmpNewQuestion.key, newIndex, prevIndex);
      }
      newPanelQuestions.push(tmpNewQuestion);
    }
    return newPanelQuestions;
  };

  constructNewIndexKey = function (key, newIndex, prevkey) {
    if (!prevkey) return key + newIndex;
    if (key[key.length - 1] === prevkey.toString()) return key.substring(0, key.length - 1) + newIndex;
    return key + newIndex; // this should not happen i think
  };

  getFields = () => {
    var makeFieldsFlat = {};
    for (let i = 0; i < this.state.questionsSteps.length; i++) {
      this.getFlatDataFromPanel(makeFieldsFlat, i, "");
    }

    // sellers
    for (let suffix = 0; suffix < this.state.sellersData.length; suffix++) {
      this.getFlatDataFromPanel(makeFieldsFlat, 0, suffix + 2);
    }

    // buyers
    for (let suffix = 0; suffix < this.state.buyersData.length; suffix++) {
      this.getFlatDataFromPanel(makeFieldsFlat, 1, suffix + 2);
    }

    // third
    for (let suffix = 0; suffix < this.state.thirdData.length; suffix++) {
      this.getFlatDataFromPanel(makeFieldsFlat, 2, suffix + 2);
    }

    return makeFieldsFlat;
  };

  getFlatDataFromPanel = (makeFieldsFlat, indexOfPanel, suffix) => {
    var panel = this.state.questionsSteps[indexOfPanel];

    for (const question of panel.questions) {
      if (question.optionsKey) {
        var splitedCheckboxData = this.state[this.getCorrectJsonFields(indexOfPanel)][question.optionsKey + suffix];
        if (!splitedCheckboxData) continue;
        splitedCheckboxData = splitedCheckboxData.split(";:;");

        for (const option of question.options) {
          if (splitedCheckboxData.includes(option.key + suffix)) makeFieldsFlat[option.key + suffix] = true;
          else makeFieldsFlat[option.key + suffix] = false;
        }
      } else {
        makeFieldsFlat[question.key + suffix] = this.state[this.getCorrectJsonFields(indexOfPanel)][question.key + suffix] || "";
      }
    }
  };

  // ** This function will prevent showing depended fields which dont match 'their shown' requirements.
  // isDepended - does the question have any dependency at all on another field
  // dependedOn - if the question is indeed depended then is it depended on a specific value?
  // isDependedNot - same like dependedOn just opposite, that it must not be the value to be shown
  isQuestionShown = (question) => {
    if (!question.isDepended && !question.isDependedNot) return true;
    var userSelectedValues = this.getFieldRecordVal(question.dependedOn || question.isDependedNot);
    // if we depend on another value
    if (question.dependedOn) {
      // we depend on a specific value and also there is indeed some value that the user inserted/selected
      if (question.dependedOnSpecificVal && userSelectedValues) {
        // this is for checkbox multi opts selected. cat;:;dog
        if (userSelectedValues.includes(";:;")) {
          if (question.dependedOnSpecificVal.includes(";:;")) {
            var splitUserSelectedOpts = userSelectedValues.split(";:;");
            for (const userSelected of splitUserSelectedOpts) {
              if (question.dependedOnSpecificVal.includes(userSelected)) return true;
            }
            return false;
          } else {
            if (userSelectedValues.includes(question.dependedOnSpecificVal)) return true;
            else return false;
          }
        } else {
          // user does not have an option to respond with more than 1 answer (not checkboxy for example)
          if (question.dependedOnSpecificVal.includes(";:;")) {
            if (question.dependedOnSpecificVal.includes(userSelectedValues)) return true;
            else return false;
          } else {
            if (question.dependedOnSpecificVal === userSelectedValues) {
              return true;
            }
          }
        }
        return false;
      } else {
        if (userSelectedValues) return true;
        return false;
      }
    }
    if (question.isDependedNot) {
      if (question.dependedOnSpecificVal && userSelectedValues) {
        // if (question.dependedOnSpecificVal !== userSelectedValues) return true;
        if (userSelectedValues.includes(";:;")) {
          if (question.dependedOnSpecificVal.includes(";:;")) {
            var splitUserSelectedOpts = userSelectedValues.split(";:;");
            for (const userSelected of splitUserSelectedOpts) {
              if (question.dependedOnSpecificVal.includes(userSelected)) return false;
            }
            return true;
          } else {
            if (userSelectedValues.includes(question.dependedOnSpecificVal)) return false;
            else return true;
          }
        } else {
          if (question.dependedOnSpecificVal.includes(";:;")) {
            if (question.dependedOnSpecificVal.includes(userSelectedValues)) return false;
            else return true;
          } else {
            if (question.dependedOnSpecificVal === userSelectedValues) {
              return false;
            }
          }
        }
        return true;
      } else {
        if (userSelectedValues) return false;
        return true;
      }
    }
  };

  getFieldRecordVal = (key) => {
    const { sellersPanel, buyersPanel, thidPanel, propertyPanel, lawyersPanel, generalPanel } = this.state;
    for (const keyInPanel in sellersPanel) {
      if (keyInPanel === key) {
        return sellersPanel[keyInPanel];
      }
    }
    for (const keyInPanel in buyersPanel) {
      if (keyInPanel === key) {
        return buyersPanel[keyInPanel];
      }
    }
    for (const keyInPanel in thidPanel) {
      if (keyInPanel === key) {
        return thidPanel[keyInPanel];
      }
    }
    for (const keyInPanel in propertyPanel) {
      if (keyInPanel === key) {
        return propertyPanel[keyInPanel];
      }
    }
    for (const keyInPanel in lawyersPanel) {
      if (keyInPanel === key) {
        return lawyersPanel[keyInPanel];
      }
    }
    for (const keyInPanel in generalPanel) {
      if (keyInPanel === key) {
        return generalPanel[keyInPanel];
      }
    }
  };

  handlePanelChange = (index) => {
    var newFocusedPanelState = !this.state.isSectionExpended[index];

    // this.state.isSectionExpended = this.state.isSectionExpended.map((item) => {
    //   return false;
    // });
    this.state.isSectionExpended[index] = newFocusedPanelState;
    this.setState({
      isSectionExpended: this.state.isSectionExpended
    });
  };

  handleFirstInteractionWithEle = (infoKey, info) => {
    if (!info || !infoKey) return;
    if (this.state.listOfShownToolTips.includes(infoKey)) return;
    toast.warn(info, {
      position: toast.POSITION.TOP_LEFT,
      autoClose: 20000
    });
    var copyListOfShownToolTips = [...this.state.listOfShownToolTips];
    copyListOfShownToolTips.push(infoKey);
    this.setState({ listOfShownToolTips: copyListOfShownToolTips });
  };

  handleFieldChange = (e, key, panelIndex) => {
    var val = e.target && e.target.value ? e.target.value.toString() : "";
    if (e.target.id) key = e.target.id;
    const panelFieldsName = this.getCorrectJsonFields(panelIndex);
    const currentPanelFields = { ...this.state[panelFieldsName] };
    currentPanelFields[key] = val;
    this.setState({ [panelFieldsName]: currentPanelFields });
  };

  handleCheckboxChange = (key, checkBoxVal, isSelected, panelIndex) => {
    const panelFieldsName = this.getCorrectJsonFields(panelIndex);
    const currentPanelFields = { ...this.state[panelFieldsName] };

    if (isSelected) {
      if (currentPanelFields[key]) {
        currentPanelFields[key] += ";:;" + checkBoxVal;
      } else {
        currentPanelFields[key] = checkBoxVal;
      }
    } else {
      var split = currentPanelFields[key].split(";:;").filter((item) => item !== checkBoxVal);
      currentPanelFields[key] = split.join(";:;");
    }
    this.setState({ [panelFieldsName]: currentPanelFields });
  };
}

export default withRouter(QuestionsPage);
